import React from 'react'
import { useNavigate } from 'react-router'
import AuthFlow from '../components/AuthFlow'

export default function UserLogin() {
  const navigate = useNavigate()

  function handleSuccess() {
    navigate('/dashboard')
    window.location.reload()
  }

  return (
    <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50 dark:bg-gray-900 min-h-[calc(100vh-4rem)]">
      <div className="max-w-md w-full">
        <AuthFlow onSuccess={handleSuccess} />
        <div className="mt-6 text-center">
          <a href="/" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 text-sm transition-colors">
            ← Terug naar hoofdpagina
          </a>
        </div>
      </div>
    </div>
  )
}
